import React from 'react'
import { useNavigate } from 'react-router-dom'
import STPMasterCard from './STPMasterCard'


export default function STPMasterCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const MasterNavigate = (name, screenFlag) => {
        if (name === "Tanks Details") {
            navigate(`/stpmastertankdetailsdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Energy MPC No") {
            navigate(`/masterenergympcnodata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Equipment Master") {
            navigate(`/stpequipmentmasterdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Equipment Work") {
            navigate(`/stpequipmentworkdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Quality Parameter") {
            navigate(`/stpqualityparameterdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }
    const navigate = useNavigate()

    return (
        <div className=' pb-0 mb-0'>
            <div className="row">
                <h5 className="ml-4 py-2">Master</h5>
            </div>
            <div className='row mast_row gar_new_mas m-0' >

                {/* <div className='col-12 col-lg-2 col-md-6 text-center mast_card_width'> */}
                <div class="mb-0 col-sm-6 mastercard ">
                    <STPMasterCard
                        title="Tanks Details"
                        cardName='py-2 green cursor '
                        masterCard='card-body mastercardborderpink'
                        count={Countdata.TankMasterTotalCount ? Countdata.TankMasterTotalCount : '0'}
                        // navLink='/stpmastertankdetailsdata'
                        imgPath="./assets/img/tank.png"
                        color='red'
                        MasterNavigate={MasterNavigate}

                    />
                </div>
                <div class="mb-0 col-sm-6 mastercard">
                    <STPMasterCard
                        title="Energy MPC No"
                        cardName='py-2 blue cursor'
                        masterCard='card-body mastercardborderblue'
                        count={Countdata.EnergyMPCNoTotalCount ? Countdata.EnergyMPCNoTotalCount : '0'}
                        // navLink='/roaddivider'
                        imgPath="./assets/img/energy-master.png"
                        color='blue'
                        MasterNavigate={MasterNavigate}
                    />
                </div>

                <div class="mb-0 col-sm-6 mastercard">
                    <STPMasterCard
                        title="Equipment Master"
                        cardName='py-2 green cursor'
                        masterCard='card-body mastercardborderpink'
                        count={Countdata.EquipmentMasterTotalCount ? Countdata.EquipmentMasterTotalCount : '0'}
                        // navLink='/openspace'
                        imgPath="./assets/img/repair-master.png"
                        color='red'
                        MasterNavigate={MasterNavigate}
                    />
                </div>

                <div class="mb-0 col-sm-6 mastercard">
                    <STPMasterCard
                        title="Equipment Work"
                        cardName='py-2 blue cursor'
                        masterCard='card-body mastercardborderblue'
                        count={Countdata.EquipmentWorkTotalCount ? Countdata.EquipmentWorkTotalCount : '0'}
                        // navLink='/treebelt'
                        imgPath="./assets/img/maintenance-master.png"
                        color='blue'
                        MasterNavigate={MasterNavigate}
                    />
                </div>
                <div class="mb-0 col-sm-6 mastercard">
                    <STPMasterCard
                        title="Quality Parameter"
                        cardName='py-2 green cursor'
                        masterCard='card-body mastercardborderpink'
                        count={Countdata.QualityParameterTotalCount ? Countdata.QualityParameterTotalCount : '0'}
                        // navLink='/chowks'
                        imgPath="./assets/img/high-quality-master.png"
                        color='red'
                        MasterNavigate={MasterNavigate}
                    />
                </div>


            </div>


        </div>



    )

}

